import { useContext } from 'react';
import AuthContext from '../context/authContext';

/**
 * useAuthContext is a convenience hook to access the auth context
 */
export default function useAuthContext() {
  return useContext(AuthContext);
}
